import axios from "axios";
import store from "../store";
import {setNetworkConnection} from "../actions/serverFunctions";

const headers = {
  "Content-Type": "application/json"
};

const AxiosInstance = axios.create({
  // baseURL: process.env.REACT_APP_API_BASE_URL + '/api/',
  // timeout: 120000,
  headers
});

AxiosInstance.interceptors.response.use((response) => {
  const {serverState} = store.getState();
  if (!serverState.networkConnection) {
    store.dispatch(setNetworkConnection(true))
  }
  return response;
}, (error) => {
  // Do something with response error
  if (error && error.toJSON && error.toJSON().message === "Network Error") {
    store.dispatch(setNetworkConnection(false))
  }
  return Promise.reject(error);
});

export default AxiosInstance;


export const apiResponseError = response => {
  // console.log("apiResponseError", response);
  if (response && response.data && response.data.errors) {
    return Object.keys(response.data.errors)
      .map(k => `${k} - ${response.data.errors[k]}`)
      .join('<br />');
  }
  if (response && response.error) {
    return response.error;
  }

  return null;
};

export const apiGet = async url => {
  try {
    const response = await AxiosInstance.get(url);
    return {data: {...response.data}, error: apiResponseError(response)};
  } catch (error) {
    return {error: apiResponseError(error)};
  }
};

export const apiPost = async (url, data) => {
  console.log("url to post", url);
  console.log("data to post", data);
  try {
    const response = await AxiosInstance.post(url, data);
    console.log("response1", response);
    return {data: {...response.data}, error: apiResponseError(response)};
  } catch (error) {
    console.log("response1 error", error);
    return {error: apiResponseError(error)};
  }
}

